var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllergies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.202 3.68107C17.2783 2.60471 18.7382 2 20.2604 2C21.7827 2 23.2425 2.60471 24.3189 3.68107C25.3953 4.75745 26 6.21733 26 7.73956C26 9.26177 25.3953 10.7217 24.3189 11.798L11.7976 24.3194C10.7212 25.3956 9.2614 26.0002 7.73923 26C6.21715 25.9999 4.75738 25.3952 3.68117 24.3188C2.60496 23.2424 2.00039 21.7827 2.00049 20.2605C2.0006 18.7384 2.60527 17.2786 3.68169 16.2024L16.202 3.68107Z",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5237 7.36035L20.6395 15.4767L15.4738 20.6421L7.35801 12.5257L12.5237 7.36035Z",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.087 6.17407C22.2311 6.17407 22.3479 6.05727 22.3479 5.9132C22.3479 5.76914 22.2311 5.65234 22.087 5.65234",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0872 6.17407C21.9431 6.17407 21.8263 6.05727 21.8263 5.9132C21.8263 5.76914 21.9431 5.65234 22.0872 5.65234",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3479 9.56567C22.492 9.56567 22.6088 9.44887 22.6088 9.30481C22.6088 9.16074 22.492 9.04395 22.3479 9.04395",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3479 9.56567C22.2038 9.56567 22.087 9.44887 22.087 9.30481C22.087 9.16074 22.2038 9.04395 22.3479 9.04395",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9568 9.3059C19.1009 9.3059 19.2177 9.18911 19.2177 9.04504C19.2177 8.90097 19.1009 8.78418 18.9568 8.78418",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9565 9.3059C18.8125 9.3059 18.6957 9.18911 18.6957 9.04504C18.6957 8.90097 18.8125 8.78418 18.9565 8.78418",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6957 5.9143C18.8398 5.9143 18.9565 5.79751 18.9565 5.65344C18.9565 5.50937 18.8398 5.39258 18.6957 5.39258",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6958 5.9143C18.5517 5.9143 18.4349 5.79751 18.4349 5.65344C18.4349 5.50937 18.5517 5.39258 18.6958 5.39258",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04395 19.218C9.18805 19.218 9.30481 19.1012 9.30481 18.9572C9.30481 18.8131 9.18805 18.6963 9.04395 18.6963",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04395 19.218C8.89985 19.218 8.78308 19.1012 8.78308 18.9572C8.78308 18.8131 8.89985 18.6963 9.04395 18.6963",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65259 18.9563C5.79669 18.9563 5.91345 18.8395 5.91345 18.6954C5.91345 18.5513 5.79669 18.4346 5.65259 18.4346",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65271 18.9563C5.50861 18.9563 5.39185 18.8395 5.39185 18.6954C5.39185 18.5513 5.50861 18.4346 5.65271 18.4346",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91358 22.3469C6.05768 22.3469 6.17444 22.2302 6.17444 22.0861C6.17444 21.942 6.05768 21.8252 5.91358 21.8252",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9137 22.3469C5.7696 22.3469 5.65284 22.2302 5.65284 22.0861C5.65284 21.942 5.7696 21.8252 5.9137 21.8252",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30481 22.6086C9.44891 22.6086 9.56567 22.4919 9.56567 22.3478C9.56567 22.2037 9.44891 22.0869 9.30481 22.0869",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30481 22.6086C9.16071 22.6086 9.04395 22.4919 9.04395 22.3478C9.04395 22.2037 9.16071 22.0869 9.30481 22.0869",
    stroke: "#4F84E8",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergies);
export default __webpack_public_path__ + "static/media/allergies.4803b3f0f3868bbcde96a6d1f410fd7b.svg";
export { ForwardRef as ReactComponent };